module.exports = __webpack_public_path__ + "media/theme/wall__sidebar--dmm-497e176e.svg";